import type { ReactNode } from "react";

const FEATURE_NUMBER_PATTERN =
	/(?<![\w.])(?:~?\d{1,3}(?:,\d{3})*(?:\.\d+)?(?:\+)?(?:\s*[-–]\s*~?\d{1,3}(?:,\d{3})*(?:\.\d+)?(?:\+)?)*(?:\s*(?:-|–)?\s*(?:[kK]|[mM]|hours?|hrs?|minutes?|minute|days?|day|weeks?|week|months?|month|years?|year|on-\d+))?|~?\d{1,3}(?:,\d{3})*-on-\d{1,3}(?:,\d{3})?)(?![\w-])/gi;

export function highlightPricingTextFeatures(text: string): ReactNode[] {
	if (!text) {
		return [""];
	}

	const parts = text.matchAll(FEATURE_NUMBER_PATTERN);
	const matches = Array.from(parts);

	if (matches.length === 0) {
		return [text];
	}

	const nodes: ReactNode[] = [];
	let cursor = 0;

	for (const match of matches) {
		const matchedValue = match[0];
		if (match.index === undefined) continue;

		nodes.push(text.slice(cursor, match.index));
		nodes.push(
			<span
				key={`pricing-feature-number-${match.index}`}
				className="font-bold text-red-600"
			>
				{matchedValue}
			</span>,
		);
		cursor = match.index + matchedValue.length;
	}

	nodes.push(text.slice(cursor));

	return nodes;
}
